var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from './../../../../shared/models/filter-data';
var TarifasFilter = /** @class */ (function (_super) {
    __extends(TarifasFilter, _super);
    function TarifasFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.DESC_TARIFA = '';
        _this.COD_TARIFA = '';
        return _this;
    }
    return TarifasFilter;
}(FilterData));
export { TarifasFilter };
